
import { ApiGateway } from '../config/config'

export const getRequestConfig = async () => {
  return {
    headers: {        
      'Content-Type': 'application/json'
    }
  }
}

export function getHostUrl() {
  return `${[window.location.protocol,'//',
  window.location.hostname,
  window.location.hostname === 'localhost' ? [':',window.location.port].join('') : ''].join('')}`
}